<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.update_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <p class="text-center">{{ $t("PLACEHOLDERS.media") }}</p>
          <UploadMedia
            :for_id="'ad_images'"
            :content="$t('PLACEHOLDERS.media')"
            ref="ad_images"
            accept="image/*,video/*"
          />
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            required
          />
          <base-select-input
            col="6"
            :optionsList="url_types"
            :placeholder="$t('PLACEHOLDERS.url_type')"
            v-model="data.url_type"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.external_link')"
            v-model.trim="data.external_link"
            v-if="data.url_type?.value === 'external_link'"
            required
          />
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";
import UploadMedia from "../../../components/formInputs/UploadMedia.vue";

export default {
  name: "EditAds",

  components: { BaseImageUploadInput, UploadMedia },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        

},
        type: null,
        nameAr: null,
        nameEn: null,
        active: true,
        descAr: null,
        descEn: null,
        publish_start_date: null,
        publish_end_date: null,
        media: null,
        media_type: null,
        url_type: null,
        external_link: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    url_types() {
      return [
        {
          id: 0,
          name: this.$t("PLACEHOLDERS.external_link"),
          value: "external_link",
        },
      ];
    },
  },
  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage2(selectedImage) {
      this.data.image2 = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.nameAr) {
        REQUEST_DATA.append("name[ar]", this.data.nameAr);
      }

      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }

      if (this.$refs.ad_images?.getFiles()[0]?.file instanceof File) {
        REQUEST_DATA.append(`file`, this.$refs.ad_images?.getFiles()[0].file);
      }
      if (this.data.publish_start_date) {
        REQUEST_DATA.append("start_date", this.data.publish_start_date);
      }
      if (this.data.publish_end_date) {
        REQUEST_DATA.append("end_date", this.data.publish_end_date);
      }
      if (this.data.url_type) {
        REQUEST_DATA.append("url_type", this.data.url_type.value);
      }
      if (
        this.data.external_link &&
        this.data.url_type.value === "external_link"
      ) {
        REQUEST_DATA.append("url", this.data.external_link);
      }
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `advertisements/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/sliders/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `advertisements/${this.$route.params.id}`,
        });
        this?.$refs?.ad_images.setFiles([
          {
            id: "id",
            url: res.data.data.Slider?.media,
          },
        ]);
        this.data.nameAr = res.data.data.data?.name_ar;
        this.data.nameEn = res.data.data.data?.name_en;
        this?.$refs?.ad_images.setFiles([
          {
            id: "id",
            url: res.data.data.data?.file,
          },
        ]);
        this.data.publish_start_date = res.data.data.data?.start_date;
        this.data.publish_end_date = res.data.data.data?.end_date;
        this.data.url_type = this.url_types.find(
          (type) => type.value === res.data.data.data?.url_type
        );
        this.data.external_link = res.data.data.data?.url;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
